import { render, staticRenderFns } from "./DetalhesCompraDireta.vue?vue&type=template&id=46091a81&scoped=true"
import script from "./DetalhesCompraDireta.vue?vue&type=script&lang=js"
export * from "./DetalhesCompraDireta.vue?vue&type=script&lang=js"
import style0 from "./DetalhesCompraDireta.vue?vue&type=style&index=0&id=46091a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46091a81",
  null
  
)

export default component.exports